'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pager;
exports.createReducer = createReducer;

var _utils = require('../utils');

var _actions = require('../actions');

var defaultInitialState = {
    totalItems: 0,
    totalPages: 0,
    currentPage: 0,
    offset: 0
};

function pager() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultInitialState;
    var action = arguments[1];

    switch (action.type) {
        case _actions.PAGER_OFFSET_CHANGE:
            return Object.assign({}, state, {
                offset: (0, _utils.clamp)(state.offset + action.offset, 0, (0, _utils.clamp)(state.totalPages - action.pagerLength, 0, state.totalPages))
            });
        case _actions.PAGER_UPDATE:
            return Object.assign({}, state, action.pagination, {
                offset: (0, _utils.clamp)(Math.floor(action.pagination.currentPage - action.pagerLength / 2), 0, (0, _utils.clamp)(state.totalPages - action.pagerLength, 0, state.totalPages))
            });
        default:
            return state;
    }
}

function createReducer(stateKey) {
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.assign({}, defaultInitialState, initialState);
        var action = arguments[1];

        if (!action.stateKey || action.stateKey !== stateKey) {
            return state;
        }

        return pager(state, action);
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-pagination/lib/reducer/index.js
// module id = 1728
// module chunks = 1